import React, { createContext, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthHeaders, PATH_INFO } from "../pages/util/helper";

type MeasurementsErrorType = {
  id: number
  brand_name: string
  error_minus: string
  error_plus: string
  measure_name: string
}

export const MeasurementsErrorContext = createContext<{
  measurementsError: MeasurementsErrorType[]
}>({
  measurementsError: []
})

export const UpdateMeasurementsErrorContext = createContext<{
  refreshMeasurementsError: (id: string) => void
}>({
  refreshMeasurementsError: async (id: string) => { }
})

export function useMeasurementsErrorContext() {
  const [measurementsError, setMeasurementsError] = useState([])

  const navigate = useNavigate()

  const refreshMeasurementsError = useCallback(async (id: string) => {
    try {
      const headers = getAuthHeaders(navigate, {
        'Content-Type': 'application/json',
      })
      if (!headers) {
        return
      }

      const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/admin/measurement-error/${id}`, {
        method: "GET",
        headers,
      })
      if (res.status === 401) {
        sessionStorage.removeItem('token')
        navigate(PATH_INFO.LOGIN.PATH)
      }

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await res.json();
      setMeasurementsError(data);
    } catch (error) {
      console.error("Error fetching measurements error.");
    }
  }, [navigate])

  return {
    measurementsError,
    refreshMeasurementsError,
  }
}

export function MeasurementsErrorProvider({ children }: { children: React.ReactNode }) {
  const { measurementsError, refreshMeasurementsError } = useMeasurementsErrorContext()

  return (
    <UpdateMeasurementsErrorContext.Provider value={{ refreshMeasurementsError }}>
      <MeasurementsErrorContext.Provider value={{ measurementsError }}>
        {children}
      </MeasurementsErrorContext.Provider>
    </UpdateMeasurementsErrorContext.Provider>
  )
}